module.exports = __webpack_public_path__ + "img/error.5f09d1a7.svg";